import { EventService, } from '@office-start/metaos-hub-sdk';
// Implementation of ILifecycleService
export class LifecycleService {
    constructor(cacheabilityDataService) {
        this.cacheabilityDataService = cacheabilityDataService;
    }
}
// Implementation of ICacheabilityDataService
export class CacheabilityDataService extends EventService {
    constructor(constraints = CachingConstraintsService.getInstance()) {
        super();
        this.constraints = constraints;
    }
}
// Implementation of ICachingConstraintsService as a Singleton
class CachingConstraintsService {
    constructor() {
        this.appExpirationInMinutes = 60;
        this.maxAppsAllowedInCache = 3;
        this.minFreeDeviceMemoryInMbToCache = 200;
        this.maxHostMemoryAllowedInMb = 2000;
    }
    static getInstance() {
        if (!this.instance) {
            synchronized(this.lock, () => {
                if (!this.instance) {
                    this.instance = new CachingConstraintsService();
                }
            });
        }
        return this.instance;
    }
}
CachingConstraintsService.lock = new Object();
// Helper function to simulate synchronized block
function synchronized(lock, fn) {
    const isLocked = lock.__locked;
    if (isLocked) {
        throw new Error('Lock is already acquired');
    }
    lock.__locked = true;
    try {
        fn();
    }
    finally {
        lock.__locked = false;
    }
}
//# sourceMappingURL=AppHostLifecycleService.js.map